module.exports = __webpack_public_path__ + "img/up-user-details-background.84295f2e.jpg";